export default __webpack_public_path__ + "static/media/img-b-result-distance-fr_fr@2x.31ee1582.jpg";